// import components
import { Box, styled, TextField, TextFieldProps } from '@mui/material';

export const StyledMainDatePickerBox = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  position: 'relative'
}));

// Note: we need to prevent max width due to DatePicker's selection area.
const withInputWidth = (width: string) => ({
  '& .MuiInputAdornment-root': {
    marginLeft: 'auto'
  },
  '& .MuiInputBase-input': {
    width
  }
});

export const StyledCustomDatePickerTextField = styled(
  TextField
)<TextFieldProps>(() => withInputWidth('75px'));

// The month picker spells its value out as "MMMM YYYY", which needs more room.
export const StyledMonthYearDatePickerTextField = styled(
  TextField
)<TextFieldProps>(() => withInputWidth('130px'));
